import React from 'react';

interface FormHeaderComponentProps {
  title: string;
}

export const FormHeaderComponent: React.FC<FormHeaderComponentProps> = React.memo(
  ({ title }: FormHeaderComponentProps) => (
    <React.Fragment>
      <h1 className="fc-text-align--left-md-center fr-text--title-blue-france">{title}</h1>
      <p className="fc-text-align--left-md-center fr-text--lg">
        En remplissant ce formulaire un mail sera envoyé au support FranceConnect afin d’analyser le
        problème rencontré. Nous vous recontacterons sous peu pour mieux vous aider.
      </p>
    </React.Fragment>
  ),
);

FormHeaderComponent.displayName = 'FormHeaderComponent';
